// ES-1661: the switch card hides for 7 days after a dismiss, browser-only (D3).
export const DISMISS_KEY = "enroll-talent-switch-card-dismissed-at";
export const DISMISS_DURATION_MS = 7 * 24 * 60 * 60 * 1000;

// Private mode or blocked storage throws on access: the card must still render.
const getStorage = () => {
  try {
    return window.localStorage;
  } catch (error) {
    return null;
  }
};

export const isDismissed = (now = Date.now(), storage = getStorage()) => {
  try {
    const raw = storage ? storage.getItem(DISMISS_KEY) : null;
    if (raw === null) {
      return false;
    }
    const dismissedAt = Number(raw);
    // A corrupt or future value must not hide the card forever.
    if (!Number.isFinite(dismissedAt) || dismissedAt > now) {
      return false;
    }
    return now - dismissedAt < DISMISS_DURATION_MS;
  } catch (error) {
    return false;
  }
};

export const recordDismissal = (now = Date.now(), storage = getStorage()) => {
  try {
    if (storage) {
      storage.setItem(DISMISS_KEY, String(now));
    }
  } catch (error) {
    // Unwritable storage: the dismiss lasts the page life only.
  }
};
